import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mapResponse } from '@ngrx/operators';
import { delay, exhaustMap, switchMap } from 'rxjs';
import { PrinterGroupService, PrinterService } from '../../../api/services';
import { LoadingState } from '../models/loader.model';
import { printerActions } from './printer.action';
import { getErrorMessage, ZetraError } from '../../shared/errors/error-messages.helper';

export const printerloadManyEffect = createEffect(
  (actions$ = inject(Actions), compService = inject(PrinterService)) => {
    return actions$.pipe(
      ofType(printerActions.loadMany),
      exhaustMap((props) =>
        compService.printerControllerFindAllPrinter({ ...props }).pipe(
          delay(1000),
          mapResponse({
            next: (r) =>
              printerActions.loadManyDone({
                data: r.data,
                state: { value: LoadingState.SUCCESS },
                loadManyModal: props.loadManyModal,
              }),
            error: (error: { message: string }) =>
              printerActions.loadManyDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: "Impossibile recuperare l'elenco dei modelli." },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);
export const printerloadOneEffect = createEffect(
  (actions$ = inject(Actions), compService = inject(PrinterService)) => {
    return actions$.pipe(
      ofType(printerActions.loadOne),
      exhaustMap((props) =>
        compService.printerControllerFindOnePrinter({ ...props }).pipe(
          delay(1000),
          mapResponse({
            next: (r) => printerActions.loadOneDone({ data: r.data, state: { value: LoadingState.SUCCESS } }),
            error: (error: { message: string }) =>
              printerActions.loadOneDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: "Impossibile recuperare l'elenco dei modelli." },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);
export const printerEditEffect = createEffect(
  (actions$ = inject(Actions), compService = inject(PrinterService)) => {
    return actions$.pipe(
      ofType(printerActions.edit),
      exhaustMap((props) =>
        compService.printerControllerUpdatePrinter({ ...props }).pipe(
          delay(1000),
          mapResponse({
            next: (r) => printerActions.editDone({ data: r.data, state: { value: LoadingState.SUCCESS } }),
            error: (error: { message: string }) =>
              printerActions.editDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: 'Impossibile modificare il dispositivo.' },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);
export const printeDeleteEffect = createEffect(
  (actions$ = inject(Actions), compService = inject(PrinterService)) => {
    return actions$.pipe(
      ofType(printerActions.deleteOne),
      exhaustMap((props) =>
        compService.printerControllerDeletePrinter({ ...props }).pipe(
          delay(1000),
          mapResponse({
            next: (r) => printerActions.deleteOneDone({ data: r.data, state: { value: LoadingState.SUCCESS } }),
            error: (error: { message: string }) =>
              printerActions.deleteOneDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: 'Impossibile eliminare il dispositivo.' },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);
export const printeGroupLoadManyEffect = createEffect(
  (actions$ = inject(Actions), compService = inject(PrinterGroupService)) => {
    return actions$.pipe(
      ofType(printerActions.loadManyGroup),
      exhaustMap((props) =>
        compService.printerGroupControllerFindAllPrinterGroup({ ...props }).pipe(
          delay(1000),
          mapResponse({
            next: (r) => printerActions.loadManyGroupDone({ data: r.data, state: { value: LoadingState.SUCCESS } }),
            error: (error: { message: string }) =>
              printerActions.loadManyGroupDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: "Impossibile recuperare l'elenco dei gruppi di dispositivi." },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);

export const printeGroupCreateEffect = createEffect(
  (actions$ = inject(Actions), compService = inject(PrinterGroupService)) => {
    return actions$.pipe(
      ofType(printerActions.createGroup),
      exhaustMap((props) =>
        compService.printerGroupControllerCreatePrinterGroup({ ...props }).pipe(
          delay(1000),
          mapResponse({
            next: (r) => printerActions.createGroupDone({ data: r.data, state: { value: LoadingState.SUCCESS } }),
            error: (error: { message: string }) =>
              printerActions.createGroupDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: 'Impossibile creare un gruppo di dispositivi.' },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);

export const loadOneGroupEffect = createEffect(
  (actions$ = inject(Actions), compService = inject(PrinterGroupService)) => {
    return actions$.pipe(
      ofType(printerActions.loadOneGroup),
      exhaustMap((props) =>
        compService.printerGroupControllerFindOnePrinterGroup({ ...props }).pipe(
          delay(1000),
          mapResponse({
            next: (r) => printerActions.loadOneGroupDone({ data: r.data, state: { value: LoadingState.SUCCESS } }),
            error: (error: { message: string }) =>
              printerActions.loadOneGroupDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: 'Impossibile recuperare il gruppo di stampanti' },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);

export const editGroupEffect = createEffect(
  (actions$ = inject(Actions), compService = inject(PrinterGroupService)) => {
    return actions$.pipe(
      ofType(printerActions.editGroup),
      exhaustMap((props) =>
        compService.printerGroupControllerUpdatePrinterGroup({ ...props }).pipe(
          delay(1000),
          mapResponse({
            next: (r) => printerActions.editGroupDone({ data: r.data, state: { value: LoadingState.SUCCESS } }),
            error: (error: { message: string }) =>
              printerActions.editGroupDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: 'Impossibile recuperare il gruppo di stampanti' },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);
export const deleteGroupEffect = createEffect(
  (actions$ = inject(Actions), compService = inject(PrinterGroupService)) => {
    return actions$.pipe(
      ofType(printerActions.deleteGroup),
      exhaustMap((props) =>
        compService.printerGroupControllerDeletePrinterGroup({ ...props }).pipe(
          delay(1000),
          mapResponse({
            next: () => printerActions.deleteGroupDone({ state: { value: LoadingState.SUCCESS } }),
            error: (error: { message: string }) =>
              printerActions.deleteGroupDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: 'Impossibile eliminare il gruppo di stampanti.' },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);
// real time metrics request
export const realTimeMetricsRequestEffect = createEffect(
  (actions$ = inject(Actions), printerService = inject(PrinterService)) => {
    return actions$.pipe(
      ofType(printerActions.realTimeMetricsRequest),
      exhaustMap((props) =>
        printerService.printerControllerSendInstantMetricsRequest(props).pipe(
          delay(1000),
          mapResponse({
            next: (r) =>
              printerActions.realTimeMetricsRequestDone({
                data: r.data,
                state: { value: LoadingState.SUCCESS },
                request: props,
              }),
            error: (error: ZetraError) =>
              printerActions.realTimeMetricsRequestDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: getErrorMessage(error.errorCode) },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);
// real time metrics request multiple
export const realTimeMetricsRequestMultipleEffect = createEffect(
  (actions$ = inject(Actions), printerService = inject(PrinterService)) => {
    return actions$.pipe(
      ofType(printerActions.realTimeMetricsRequestMultiple),
      exhaustMap((props) =>
        printerService.printerControllerSendInstantMetricsRequestMultiple(props).pipe(
          delay(1000),
          mapResponse({
            next: (r) =>
              printerActions.realTimeMetricsRequestMultipleDone({
                data: r.data,
                state: { value: LoadingState.SUCCESS },
              }),
            error: (error: ZetraError) =>
              printerActions.realTimeMetricsRequestMultipleDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: getErrorMessage(error.errorCode) },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);
export const editPrintersManageEffect = createEffect(
  (actions$ = inject(Actions), printerService = inject(PrinterService)) => {
    return actions$.pipe(
      ofType(printerActions.editPrintersManage),
      exhaustMap((props) =>
        printerService.printerControllerUpdateManaged(props).pipe(
          delay(1000),
          mapResponse({
            next: (r) =>
              printerActions.editPrintersManageDone({
                data: r.data,
                state: { value: LoadingState.SUCCESS },
              }),
            error: (error: ZetraError) =>
              printerActions.editPrintersManageDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: getErrorMessage(error.errorCode) },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);

export const statusCodeStatsEffect = createEffect(
  (actions$ = inject(Actions), printerService = inject(PrinterService)) => {
    return actions$.pipe(
      ofType(printerActions.statusCodeStats),
      switchMap((props) =>
        printerService.printerControllerGetPrinterStats(props).pipe(
          delay(1000),
          mapResponse({
            next: (r) =>
              printerActions.statusCodeStatsDone({
                data: r.data,
                state: { value: LoadingState.SUCCESS },
              }),
            error: (error: ZetraError) =>
              printerActions.statusCodeStatsDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: getErrorMessage(error.errorCode) },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);

export const loadDataReportEffect = createEffect(
  (actions$ = inject(Actions), printerService = inject(PrinterService)) => {
    return actions$.pipe(
      ofType(printerActions.loadDataReport),
      exhaustMap((props) =>
        printerService.printerControllerPrinterReportConsumableTrend(props).pipe(
          delay(1000),
          mapResponse({
            next: (r) =>
              printerActions.loadDataReportDone({
                data: r.data,
                state: { value: LoadingState.SUCCESS },
              }),
            error: (error: ZetraError) =>
              printerActions.loadDataReportDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: getErrorMessage(error.errorCode) },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);
export const loadCountersReportEffect = createEffect(
  (actions$ = inject(Actions), printerService = inject(PrinterService)) => {
    return actions$.pipe(
      ofType(printerActions.loadCountersReport),
      exhaustMap((props) =>
        printerService.printerControllerPrinterReportCountersTrend(props).pipe(
          delay(1000),
          mapResponse({
            next: (r) =>
              printerActions.loadCountersReportDone({
                data: r.data,
                state: { value: LoadingState.SUCCESS },
              }),
            error: (error: ZetraError) =>
              printerActions.loadCountersReportDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: getErrorMessage(error.errorCode) },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);

export const loadStatusTrendReportEffect = createEffect(
  (actions$ = inject(Actions), printerService = inject(PrinterService)) => {
    return actions$.pipe(
      ofType(printerActions.loadStatusTrendReport),
      exhaustMap((props) =>
        printerService.printerControllerPrinterReportStatusTrend(props).pipe(
          delay(1000),
          mapResponse({
            next: (r) =>
              printerActions.loadStatusTrendReportDone({
                data: r.data,
                state: { value: LoadingState.SUCCESS },
              }),
            error: (error: ZetraError) =>
              printerActions.loadStatusTrendReportDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: getErrorMessage(error.errorCode) },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);

export const loadTrendForecastEffect = createEffect(
  (actions$ = inject(Actions), printerService = inject(PrinterService)) => {
    return actions$.pipe(
      ofType(printerActions.loadTrendForecast),
      exhaustMap((props) =>
        printerService.printerControllerPrinterTrendsAndForecast(props).pipe(
          mapResponse({
            next: (r) =>
              printerActions.loadTrendForecastDone({
                data: r.data,
                state: { value: LoadingState.SUCCESS },
              }),
            error: (error: ZetraError) =>
              printerActions.loadTrendForecastDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: getErrorMessage(error.errorCode) },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);

export const loadCountersAnalyticsReportEffect = createEffect(
  (actions$ = inject(Actions), printerService = inject(PrinterService)) => {
    return actions$.pipe(
      ofType(printerActions.loadCountersAnalyticsReport),
      exhaustMap((props) =>
        printerService.printerControllerPrinterReportCountersAnalyticsTrend(props).pipe(
          delay(1000),
          mapResponse({
            next: (r) =>
              printerActions.loadCountersAnalyticsReportDone({
                data: r.data,
                state: { value: LoadingState.SUCCESS },
              }),
            error: (error: ZetraError) =>
              printerActions.loadCountersAnalyticsReportDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: getErrorMessage(error.errorCode) },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);

export const loadAlertDescriptionsReportEffect = createEffect(
  (actions$ = inject(Actions), printerService = inject(PrinterService)) => {
    return actions$.pipe(
      ofType(printerActions.loadAlertDescriptionsReport),
      exhaustMap((props) =>
        printerService.printerControllerPrinterReportAlertDescriptions(props).pipe(
          delay(1000),
          mapResponse({
            next: (r) =>
              printerActions.loadAlertDescriptionsReportDone({
                data: r.data,
                state: { value: LoadingState.SUCCESS },
              }),
            error: (error: ZetraError) =>
              printerActions.loadAlertDescriptionsReportDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: getErrorMessage(error.errorCode) },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);

export const loadPrinterThresholdsEffect = createEffect(
  (actions$ = inject(Actions), printerService = inject(PrinterService)) => {
    return actions$.pipe(
      ofType(printerActions.loadPrinterThresholds),
      exhaustMap((props) =>
        printerService.printerControllerGetThresholds(props).pipe(
          mapResponse({
            next: (r) =>
              printerActions.loadPrinterThresholdsDone({
                data: r.data,
                state: { value: LoadingState.SUCCESS },
              }),
            error: (error: ZetraError) =>
              printerActions.loadPrinterThresholdsDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: getErrorMessage(error.errorCode) },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);
